// EventDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FloatingMenu from '../components/FloatingMenu';

const EventDetail = () => {
    const { id } = useParams();
    const [eventData, setEventData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://cms.okoce.net/api/admin/events/${id}`);
                if (!response.ok) {
                    throw new Error('Gagal mengambil data event');
                }
                const data = await response.json();
                setEventData(data.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!eventData) {
        return <p>Event tidak ditemukan</p>;
    }

    return (
        <>
            <div className="max-w-4xl mx-auto mt-24 p-4">
                <div className="bg-white shadow-md rounded-lg lg:p-5">
                    <img className="object-cover w-full h-full" src={`${process.env.REACT_APP_API_URL}/${eventData.image}`} alt="" />
                    <div className="grid mobile:grid-cols-1 lg:grid-cols-2">
                        <div>
                            <h2 className="font-extrabold text-3xl mb-2 mt-12 mobile:ml-4 lg:ml-10">{eventData.title}</h2>
                        </div>
                        <div>
                            <p className="text-zinc-700 font-medium text-2xl mobile:mt-2 mobile:ml-4 lg:mt-12 lg:ml-64">Rp{eventData.price.toLocaleString()}</p>
                        </div>
                    </div>
                    <div className="mt-4 mb-10 mobile:ml-4 lg:ml-10">
                        <p className="text-lg">Inisiator Event<br /></p>
                        <p className="font-extrabold text-[#e01f31] text-xl">{eventData.source}</p>
                    </div>
                    <div className="w-[90%] mx-auto border-b-2 border-[#1c75ac]">
                        <p className=" text-lg text-black text-justify pb-4" dangerouslySetInnerHTML={{ __html: eventData.description }} />
                    </div>
                    <div className="w-[90%] mx-auto border-b-2 border-[#1c75ac] pt-6 grid justify-between mobile:grid-cols-2 mobile:gap-2 mobile:grid-flow-row lg:grid-cols-3">
                        <div className="bg-gray-100 rounded-xl mobile:w-full lg:w-48">
                            <h3 className="w-full bg-[#1c75ac] pl-3 text-start py-1 font-semibold text-lg text-white">Tanggal Event</h3>
                            <p className="mt-2 text-black font-bold text-xl pl-3 py-1">{eventData.date}
                            </p>
                        </div>
                        <div className="bg-gray-100 rounded-xl mobile:w-full lg:w-48">
                            <h3 className="w-full bg-[#1c75ac] pl-3 text-start py-1 font-semibold text-lg text-white">Waktu</h3>
                            <p className="mt-2 text-black font-bold text-xl pl-3 py-1">{eventData.duration}
                            </p>
                        </div>
                        <div className="bg-gray-100 rounded-xl mobile:w-full lg:w-48">
                            <h3 className="w-full bg-[#1c75ac] pl-3 text-start py-1 font-semibold text-lg text-white">Kuota</h3>
                            <p className="mt-2 text-black font-bold text-xl pl-3 py-1">{eventData.quota}
                            </p>
                        </div>
                        <div className="mt-10 mb-6 bg-gray-100 col-span-2 w-64 rounded-xl my-4">
                            <h3 className="w-full bg-[#1c75ac] pl-3 text-start py-1 font-semibold text-lg text-white">Lokasi</h3>
                            <p className="mt-2 text-black font-bold text-xl pl-3 py-1">{eventData.location}
                            </p>
                        </div>
                    </div>
                    <div className="w-[90%] mx-auto border-b-2 border-[#1c75ac] pt-4">
                        <h3 className="font-semibold text-xl text-[#1c75ac]">Narasumber</h3>
                        <p className="mt-2 text-2xl font-bold text-black text-justify pb-4">{eventData.source}
                        </p>
                    </div>
                </div>
            </div >
            <FloatingMenu />{" "}
        </>
    );
};

export default EventDetail;
